module.exports = __webpack_public_path__ + "img/sinclair catalog 1984 p1.40319d2c.jpg";